import { combineReducers } from 'redux';
import reviewLifecycleDuration, {
  State as ReviewLifecycleDurationState,
} from './ReviewLifecycleDuration';
import projectStats, { State as ProjectStatsState } from './ProjectStats';
import contributionVolume, {
  State as ContributionVolumeState,
} from './ContributionVolume';
import highlights, { State as HighlightsState } from './Highlights';
import projectBreakdown, {
  State as ProjectBreakdownState,
} from './ProjectBreakdown';
import staleBranches, { State as StaleBranchesState } from './StaleBranches';

export default combineReducers<ProjectDashboardState>({
  reviewLifecycleDuration,
  projectStats,
  contributionVolume,
  highlights,
  projectBreakdown,
  staleBranches,
});

export interface ProjectDashboardState {
  reviewLifecycleDuration: ReviewLifecycleDurationState;
  projectStats: ProjectStatsState;
  contributionVolume: ContributionVolumeState;
  highlights: HighlightsState;
  projectBreakdown: ProjectBreakdownState;
  staleBranches: StaleBranchesState;
}
